import { auth, ixoraoneAuth } from '../firebase';

const LOCATION_HISTORY_URL =
  'https://asia-south1-ixora-feedback-86789.cloudfunctions.net/getSupervisorLocationHistory';

async function getAdminIdToken() {
  try {
    const tok = await ixoraoneAuth.currentUser?.getIdToken();
    if (tok) return tok;
  } catch {
    /* fall through */
  }
  try {
    const tok = await auth.currentUser?.getIdToken();
    if (tok) return tok;
  } catch {
    /* fall through */
  }
  return null;
}

/** Fetch supervisor GPS for a date range (ixora-one + legacy merge, server-side). */
export async function fetchSupervisorLocationHistory({
  feedbackSupervisorUid,
  startMs,
  endMs,
  limit = 500,
  includeLive = false,
}) {
  const token = await getAdminIdToken();
  if (!token) throw new Error('Not signed in');

  const params = new URLSearchParams({
    feedbackSupervisorUid,
    startMs: String(startMs),
    endMs: String(endMs),
    limit: String(limit),
  });
  if (includeLive) params.set('includeLive', '1');

  const res = await fetch(`${LOCATION_HISTORY_URL}?${params}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok || !body.ok) {
    throw new Error(body.error || body.message || `HTTP ${res.status}`);
  }
  return body;
}

/** Normalize API samples or legacy Firestore docs into map points. */
export function locationSamplesToMapPoints(history) {
  return (history ?? [])
    .map((h) => {
      if (typeof h.lat === 'number' && typeof h.lng === 'number') {
        const t = h.capturedAtMs ?? 0;
        return {
          id: h.id,
          lat: h.lat,
          lng: h.lng,
          t,
          date: t ? new Date(t) : null,
          battery: h.battery,
          isCharging: !!h.isCharging,
          isMocked: !!h.isMocked,
          siteId: h.siteId || '',
          accuracy: h.accuracy,
          speed: h.speed,
          heading: h.heading,
        };
      }
      const loc = h.location;
      if (!loc || typeof loc.latitude !== 'number' || typeof loc.longitude !== 'number') {
        return null;
      }
      const dt = h.dateTime?.toDate ? h.dateTime.toDate() : null;
      return {
        id: h.id,
        lat: loc.latitude,
        lng: loc.longitude,
        t: dt ? dt.getTime() : 0,
        date: dt,
        battery: h.battery,
        isCharging: !!h.isCharging,
        isMocked: !!h.isMocked,
        siteId: h.siteId || '',
        accuracy: h.accuracy,
        speed: h.speed,
        heading: h.heading,
      };
    })
    .filter(Boolean);
}
